/* ------------------------------------------------------------------------ */
/*		File: hooks.ts                                                      */
/*		Description: Hooks for the component                                */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

import { apiLoader } from "./api";
import crypt from "crypto-js";

/* ------------------------------------------------------------------------ */

export const getResources = async(criteria:any) => {
    try {
        const config:any = process.env.REACT_APP_RESOURCES !== undefined ? JSON.parse(process.env.REACT_APP_RESOURCES) : {};
        const values = criteria.hasOwnProperty("tags") && criteria.tags.trim().length > 0
            ? criteria.tags.split(" ").filter(Boolean) 
            : null;

        const payload = {
            service: config.service, 
            data: {
                tags: values, 
                state: config.state,
                channels: config.channels,
            },
            authToken: {
                username: null,
                token: null, 
            }  
        }

        const response = await apiLoader(payload);
        if (response.status === 200) {
            if (response.data.count > 0) {
                return { resources: response.data.items, msg: "OK" }
            } else {
                return { resources: [],  msg: "No Items" }
            }            
        } else { 
            return { resources: null, msg: "KO" }
        }
    } catch (err) {
        return { resources: null, msg: err }
    }
}

/* ------------------------------------------------------------------------ */

export const getDetailResource = async(id: string) => {
    try {
        const config:any = process.env.REACT_APP_DETAIL_RESOURCE !== undefined ? JSON.parse(process.env.REACT_APP_DETAIL_RESOURCE) : {};
        const payload = {
            service: config.service, 
            data: {
                id: id
            },
            authToken: {
                username: null,
                token: null, 
            }  
        }

        const response = await apiLoader(payload);
        if (response.status === 200) {
            if (response.data.count > 0) {
                return { resource: response.data.items[0], msg: "OK" }
            } else {
                return { resource: {}, msg: "No Items" }
            }            
        } else { 
            return { resource: null, msg: "KO" }
        }
    } catch (err) {
        return { resource: null, msg: err }
    }
}

/* ------------------------------------------------------------------------ */

export const getPromocodes = async () => {
    const config: any = process.env.REACT_APP_PROMOCODES !== undefined ? JSON.parse(process.env.REACT_APP_PROMOCODES) : {};
    const payload = {
        service: config.service,
        data: {
            state: config.state,
            channels: config.channels,
        },
        authToken: {
            username: null,
            token: null, 
        }
    }

    try {
        const response = await apiLoader(payload);
        if (response.status === 200) {
            if (response.data.count > 0) {
                return { 
                    hasPromocode: true,
                    campaign: crypt.AES.encrypt(JSON.stringify(response.data.items), process.env.REACT_APP_ENCRYPTKEY!).toString() , 
                    msg: "OK" }
            } else {
                return { 
                    hasPromocode: false,
                    campaign: {},  
                    msg: "No Items" }
            }            
        } else { 
            return { resource: null, msg: "KO" }
        }
    } catch (error) {
        console.error("Error fetching promo codes:", error);
    }
}

/* ------------------------------------------------------------------------ */

export const setLead = async(lead: any) => {
    const config: any = process.env.REACT_APP_LEADS !== undefined ? JSON.parse(process.env.REACT_APP_LEADS) : {};
    const payload = {
        service: config.service,
        data: {
            lead: lead, 
            state: config.state,
            channels: config.channels,
        },
        authToken: {
            username: null,
            token: null, 
        }
    }

    try {
        const response = await apiLoader(payload);
        if (response.status === 200) {
            return { msg: "OK" }
        } else { 
            return { msg: "KO" }
        }
    } catch (error) {
        console.error("Error fetching leads:", error);
    }    
}

/* ------------------------------------------------------------------------ */

export const comChatbot = async(messages:any[]) => {
    const config: any = process.env.REACT_APP_CHATBOT !== undefined ? JSON.parse(process.env.REACT_APP_CHATBOT) : {};
    
    const payload = {
        service: config.service,
        url: config.url, 
        data: {
            model: config.model,
            messages: messages,
            max_tokens: 150, 
            n: 1, 
            stop: null, 
            temperature: 0.7, 
        },
        authToken: {
            username: null,
            token: config.token, 
        }
    }

    try {
        const response = await apiLoader(payload);
        if (response.status === 200) {
            return { 
                role: response.data.choices[0].message.role, 
                content: response.data.choices[0].message.content, 
                msg: "OK" 
            }
        } else { 
            return { 
                role: null,
                content:null, 
                msg: "KO" 
            }
        }
    } catch(error) {
        console.error("Error fetching chatbot:", error);
    }
}

/* ------------------------------------------------------------------------ */

export const subscribeCampaign = async(campaign: any) => {
    const config: any = process.env.REACT_APP_SUBSCRIBECAMPAIGN !== undefined ? JSON.parse(process.env.REACT_APP_SUBSCRIBECAMPAIGN) : {};
    const payload = {
        service: config.service,
        data: {
            promocode: {
                id: campaign.promocodeId,
                name: campaign.promoName, 
            },
            email: campaign.email, 
            name: campaign.name,
            surname: campaign.surname, 
            channels: config.channels,
        },
        authToken: {
            username: null,
            token: null, 
        }
    }
    try {
        const response = await apiLoader(payload);
        if (response.status === 200) {
            return { msg: "OK" }
        } else { 
            const msgError = response.data.data.error.msg.description.error.msg;
            return { msg: msgError }
        }
    } catch (error) {
        console.error("Error fetching leads:", error);
    }    
}


